// node_modules
import { FC, useEffect } from "react";
// Components
import { AsynchronousWrapper } from "Components";
import { PatentDocumentContent } from "../UsPatentDocument/PatentDocumentContent";
// Custom hooks
import { useFetch } from "Hooks";
// Types
import { TUseFetch, TUsPatentDTO } from "Types";
// styles
import styles from "./patentModalContent.module.scss";
import { PendoHelperSingleton } from "Helpers";
import { LoggingConstants } from "Constants";

type TPatentModalContentProps = {
    patentId: string
}

export const PatentModalContent: FC<TPatentModalContentProps> = ({patentId}: TPatentModalContentProps) => {
    // We use `useFetch` custom hook here
    // to fetch data from the server
    const { isLoading, didError, errorMessage, fetchedData }: TUseFetch<TUsPatentDTO> = useFetch(`api/articles/patent/${patentId}`);

    // Logging
    useEffect(() => {
        // Log the fetching of the current science article
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}ArticlesPatentGet`, {
            patentId: patentId
        });
    }, [patentId]);

    return (
        <AsynchronousWrapper didError={didError} errorMessage={errorMessage} isLoading={isLoading} LoaderComponent={null}>
            {fetchedData ?
                    <div className={[styles.patent, styles.patentModalContainer].join(" ")}>
                        <div className={styles.documentHeader}>
                            <span className={styles.documentTitle}>{fetchedData.title}</span>
                        </div>
                        <PatentDocumentContent 
                            patent={fetchedData} />
                    </div>
                :
                    <></>
            }
        </AsynchronousWrapper>
    );
}
